<template>
  <div>
    <button class="btn btn-edit" @click="openModal"><img src="@/assets/images/admin/cashpayments/edit.png" alt="Edit" style="width: 25px; height: 25px;" />
</button>

    <div class="modal fade" ref="editFleetModal" tabindex="-1" role="dialog" aria-labelledby="editFleetModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Edit fleet</h4>
            <button type="button" class="close" @click="hideModal" aria-label="Close">
              <span aria-hidden="true">X</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row d-flex align-items-stretch">
              <div class="col-md-6 d-flex">
                <div class="card flex-grow-1">
                  <div class="card-body">
                    <div class="form-group">
                      <h5 class="section-title">Contract details</h5>
                      <label for="first-name">Fleet ID</label>
                      <input type="text" id="fleet-id" class="form-control" v-model="form.fleet_id" />
                      <!-- <span v-if="errors.fleet_id" class="text-danger">{{ errors.fleet_id }}</span> -->
                    </div>
                    <div class="form-group">
                      <label for="last-name">Fleet name</label>
                      <input type="text" id="fleet-name" class="form-control" v-model="form.fleet" />
                      <!-- <span v-if="errors.fleet_name" class="text-danger">{{ errors.fleet_name }}</span> -->
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 d-flex">
                <div class="card flex-grow-1">
                  <div class="card-body">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6 col-12">
                          <span>Created:</span>
                        </div>
                        <div class="col-md-6 col-12">
                          <span>Last updated:</span>
                        </div>
                        <div class="col-md-6 col-12 mt-2">
                          <span>{{ form.created_at }}</span>
                        </div>
                        <div class="col-md-6 col-12 mt-2">
                          <span>{{ form.updated_at }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="form-group mt-4">
                      <div class="ms-2 checkbox checkbox-success">
                        <input :id="`checkbox-edit-${form.id}`" type="checkbox" v-model="form.enabled">
                        <label :for="`checkbox-edit-${form.id}`">Enabled</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <button class="btn btn-green btn-ok me-1" @click="submitForm">Save</button>
                <button class="btn btn-cancel" @click="hideModal">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { Modal } from 'bootstrap';
import { useFleetStore } from '@/store/admin/fleet';
import Swal from 'sweetalert2';

const props = defineProps({
  fleet: Object, // 接收父組件傳來的 member 資料
});

const fleetStore = useFleetStore();
const form = ref({
  fleet_id: '',
  fleet: '',
  created_at: '',
  updated_at: '',
  enabled: false,
});

const editFleetModal = ref(null);
let modalInstance = null;


const openModal = () => {
  // 將傳入的 member 資料綁定到 form 中，並將 enabled 正確轉換為布爾值
  form.value = { 
    ...props.fleet,
    enabled: props.fleet.enabled === 1, // 確保 '1' 轉換為 true，'0' 轉換為 false
  };

  if (!modalInstance) {
    modalInstance = new Modal(editFleetModal.value);
  }
  modalInstance.show();
};

const hideModal = () => {
  if (modalInstance) {
    modalInstance.hide();
  }
};

const submitForm = () => {
  const updatedForm = {
    id: form.value.id,
    fleet_id: form.value.fleet_id,
    name: form.value.fleet,
    enabled: form.value.enabled ? 1 : 0, // 在提交時將布爾值轉換為 '1' 或 '0'
  };

  fleetStore.updateFleet(updatedForm)
    .then(() => {
      hideModal();
    })
    .catch(error => {
      console.error('Error updating member:', error);
    });
};
</script>

<style scoped>
label {
  font-size: 16px;
  margin-top: 5px;
}

.btn-green {
  background: rgba(0, 201, 98, 1);
  color: black;
  border: none;
  width: 244.83px;
  height: 46px;
  border-radius: 30px;
  padding: 10px, 32px, 10px, 32px;
}

.btn-edit{
  color: #8476f5;
}

.btn-green:hover {
  background-color: #00b452;
}

.btn-ok {
  width: 150px;
}

.btn-cancel {
  background-color: #fff;
  color: #8476f4;
  border: 2px solid #8476f4;
  border-radius: 30px;
  width: 150px;
  height: 46px;
  padding: 14px 32px 14px 32px;
}

.btn-cancel:hover {
  background-color: #e6e6ff;
}

.modal-content {
  border-radius: 10px;
  padding: 20px;
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
  background-color: #d9dde3;
}

.card {
  background-color: #d9dde3;
}

.close {
  color: #333;
  opacity: 1;
  font-size: 20px;
  padding: 0;
  background: none;
  border: none;
}

.close:hover {
  color: #000;
}

.row.d-flex {
  display: flex;
}

.col-md-6.d-flex {
  display: flex;
  flex-direction: column;
}

.card.flex-grow-1 {
  flex-grow: 1;
}

.align-items-stretch {
  align-items: stretch;
}

.text-danger {
  color: red;
  font-size: 0.9em;
}
</style>
